module.exports = __webpack_public_path__ + "img/price-settings-icon-orange.bd22ca03.svg";